import React from 'react';

const AuthLayout = ({ title, subtitle, children, cardClassName = 'p-6 sm:p-7', onHomeNavigate }) => {
  const logoClassName =
    'inline-block rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500';

  const handleLogoClick = (e) => {
    if (onHomeNavigate) {
      e.preventDefault();
      onHomeNavigate();
    }
  };

  return (
  <div className="relative min-h-screen w-full flex items-center justify-center px-4 py-10">
    <div className="absolute inset-0 bg-[url('/backgroundlogin.png')] bg-cover bg-center bg-no-repeat" />

    <div className="relative z-10 w-full max-w-[440px]">
      <div className="mb-8 flex flex-col items-center gap-2">
        <a
          href="/"
          onClick={handleLogoClick}
          className={logoClassName}
          aria-label="InfluenceHub — back to home"
        >
          <img
            src="/IHBanner.png"
            alt=""
            className="h-14 sm:h-16 md:h-20 w-auto pointer-events-none"
            draggable={false}
          />
        </a>
      </div>

      <div className={`w-full max-w-[440px] rounded-2xl border border-black/5 bg-white shadow-sm ${cardClassName}`}>
        <div className="mb-6 space-y-1 text-center">
          <h1 className="text-3xl font-semibold text-slate-900">{title}</h1>
          <p className="text-sm text-slate-500">{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  </div>
  );
};

export default AuthLayout;
